import connect from './connect'
import TotalPrintsCell from './total_prints_cell'

export default connect(TotalPrintsCell)
